// import MUIDataTable from 'mui-datatables';

import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Grid,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useQuery } from "react-query";
import { addDataRequest, deleteDataRequest, getAllData, updateDataRequest } from "../api";
import { useForm, Controller } from "react-hook-form";

import React, { useCallback, useMemo } from "react";

import { Add, Delete, Download, Edit, Tune } from "@mui/icons-material";
import { Fab } from "@mui/material";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import MaterialReactTable from "material-react-table";
import { useRef, useState } from "react";
import { BsArrowDown, BsTrash } from "react-icons/bs";

import * as XLSX from "xlsx";

import { saveAs } from "file-saver";

import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import { useDownloadExcel } from "react-export-table-to-excel";
import { el, ro } from "date-fns/locale";
import useAuth from "../hooks/useAuth";
import { Alert, Snackbar } from "@mui/material";

function DataTable({ date, dates }) {
  const [didSaved, setDidSaved] = useState(0);
  const [didAdd, setDidAdd] = useState(0);
  const [didAddNew, setDidAddNew] = useState(false);
  const [showPermissionError, setShowPermissionError] = useState(false);
  const [permissionErrorMessage, setPermissionErrorMessage] = useState("");
  
  // New Business Form Dialog State
  const [openAddDialog, setOpenAddDialog] = useState(false);
  
  // React Hook Form - Optimized form handling with minimal re-renders
  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      EPONIMIA: "",
      AFM: "",
      ROAD: "",
      ROADNO: "",
      TK: "",
      CITY: "ΒΟΥΛΙΑΓΜΕΝΗ",
      BUSINESS: "YES",
      AAPAROXIS: "",
      FLNAME: "",
      FLNAME1: "",
      PHONENO: "",
      MOBILENO: "",
      EMAIL: "",
      TetrMetraDT: "",
      // Geographic coordinates
      Latitude: "",
      Longtitude: "",
      // Brown container (καφέ κάδος)
      TAGNO: "",
      RFID: "",
      COVERNO: "",
      // New Organika bin sizes
      TAGNO_Organika_120: "",
      RFID_Organika_120: "",
      FREQ_Organika_120: "",
      TAGNO_Organika_240: "",
      RFID_Organika_240: "",
      FREQ_Organika_240: "",
      TAGNO_Organika_360: "",
      RFID_Organika_360: "",
      FREQ_Organika_360: "",
      TAGNO_Organika_660: "",
      RFID_Organika_660: "",
      FREQ_Organika_660: "",
      TAGNO_Organika_1100: "",
      RFID_Organika_1100: "",
      FREQ_Organika_1100: "",
      // Green container (πράσινος κάδος) 
      TAGNO_Symmeikta: "",
      RFID_Symmeikta: "",
      COVERNO_Symmeikta: "",
      // New Symmeikta bin sizes
      TAGNO_Symmeikta_120: "",
      RFID_Symmeikta_120: "",
      FREQ_Symmeikta_120: "",
      TAGNO_Symmeikta_240: "",
      RFID_Symmeikta_240: "",
      FREQ_Symmeikta_240: "",
      TAGNO_Symmeikta_360: "",
      RFID_Symmeikta_360: "",
      FREQ_Symmeikta_360: "",
      TAGNO_Symmeikta_660: "",
      RFID_Symmeikta_660: "",
      FREQ_Symmeikta_660: "",
      TAGNO_Symmeikta_1100: "",
      RFID_Symmeikta_1100: "",
      FREQ_Symmeikta_1100: "",
      Notes: ""
    }
  });

  const { user } = useAuth();
  const tableInstanceRef = useRef(null);



  const virtualizerInstanceRef = useRef(null);

  const { isLoading, isError, data, isFetching } = useQuery(
    ["live_data", didSaved, didAdd, dates],
    () => getAllData({ page: 0, limit: null, date: date, dates: dates }),
    {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      cacheTime: 5000,
    }
  );




  const columnsNew = useMemo(() => [

    
    //  A/A
    {
      accessorKey: "id",
      header: "A/A",
      size: 100,
      enableEditing: false,
      visibility: true,
    },
    

    //ΣΤΟΙΧΕΙΑ ΕΠΙΧΕΙΡΗΣΗΣ
    {
      accessorKey: "EPONIMIA",
      header: `
      ΟΝΟΜΑ 
      ΕΠΙΧΕΙΡΗΣΗΣ
      `,
      visibility: true,

    },

    {
      accessorKey: "BUSINESS_TYPE",
      header: `
      ΚΑΤΗΓΟΡΙΑ 
      ΕΠΙΧΕΙΡΗΣΗΣ`,
      visibility: true,
    },

    {
      accessorKey: "AFM",
      header: "Α.Φ.Μ",
      size: 125,
      visibility: false
    },


   
    //ΔΙΕΥΘΥΝΣΗ ΑΚΙΝΗΤΟΥ
    {
      accessorKey: "ROAD",
      header: "ΟΔΟΣ",
      visibility: true,
    },
    {
      accessorKey: "ROADNO",
      header: "ΑΡΙΘΜΟΣ",
      size: 120,
      visibility: true,
    },

    {
      accessorKey: "Municipality",
      header: "ΔΗΜΟΣ",
      size: 130,
      visibility: false,
      
      //make header font smaller
      headerProps: {
        style: {
          fontSize: 12,
        },
      },
    },
   
    {
      accessorKey: "CITY",
      header: "Δ.Ε.",
      size: 125,
      muiTableBodyCellEditTextFieldProps: ({ cell, column, table }) => ({
        children: ["ΒΟΥΛΑ", "ΒΟΥΛΙΑΓΜΕΝΗ", "ΒΑΡΗ", "ΒΑΡΚΙΖΑ"].map((state) => (
          <MenuItem key={state} value={state} defaultValue={cell.getValue()}>
            {state}
          </MenuItem>
        )),
        select: true,
      }),
      visibility: true,
    },

    {
      accessorKey: "TK",
      header: "TK",
      size: 80,
      visibility: false,
    },

    {
      accessorKey: "Latitude",
      header: "ΓΕΩΓΡ.ΠΛΑΤΟΣ",
      visibility: false,
      
    },

    {
      accessorKey: "Longtitude",
      header: "ΓΕΩΓΡ.ΜΗΚΟΣ",
      visibility: false,
    },


  
    //ΣΤΟΙΧΕΙΑ ΠΑΡΟΧΗΣ
    {
      accessorKey: "AAPAROXIS",
      header: "Α.ΠΑΡΟΧΗΣ",
      visibility: false,
    },
    {
      accessorKey: "FLNAME",
      header: `ΙΔΙΟΚΤΗΤΗΣ AΡ. ΠΑΡΟΧΗΣ`,
      visibility: false,
    },


    //ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ
    {
      accessorKey: "FLNAME1",
      header: `ΥΠΕΥΘΥΝΟΣ ΕΠΙΚΟΙΝΩΝΙΑΣ`,
      visibility: false,
    },
    {
      accessorKey: "PHONENO",
      header: `ΣΤΑΘΕΡΟ 
      ΤΗΛΕΦΩΝΟ`,
      size: 135,
      visibility: false,
    },

    {
      accessorKey: "MOBILENO",
      header: "ΚΙΝΗΤΟ",
      size: 125,
      visibility: false,
    },

    {
      accessorKey: "EMAIL",
      header: "EMAIL",
      visibility: false,
      
    },

    
    //ΣΤΟΙΧΕΙΑ ΓΙΑ ΤΟΝ ΚΑΦΕ ΚΑΔΟ
    {
      accessorKey: "TAGNO",
      header: `TAG ΚΑΦΕ ΚΑΔΟΥ`,
      visibility: false,
    },

    {
      accessorKey: "RFID",
      header: `RFID ΚΑΦΕ ΚΑΔΟΥ`,
      visibility: false,
    },

    {
      accessorKey: "COVERNO",
      header: `BINNo  ΚΑΦΕ ΚΑΔΟΥ`,
     visibility: true,
    },

    // New bin-size-specific fields for Organika (Brown bins)
    {
      accessorKey: "TAGNO_Organika_120",
      header: `TAG ΟΡΓΑΝΙΚΩΝ 120L`,
      visibility: false,
    },
    {
      accessorKey: "RFID_Organika_120",
      header: `RFID ΟΡΓΑΝΙΚΩΝ 120L`,
      visibility: false,
    },
    {
      accessorKey: "FREQ_Organika_120",
      header: `ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 120L`,
      visibility: false,
      muiTableBodyCellEditTextFieldProps: {
        type: 'number',
        inputProps: { min: 0, max: 50 }
      }
    },

    {
      accessorKey: "TAGNO_Organika_240",
      header: `TAG ΟΡΓΑΝΙΚΩΝ 240L`,
      visibility: false,
    },
    {
      accessorKey: "RFID_Organika_240",
      header: `RFID ΟΡΓΑΝΙΚΩΝ 240L`,
      visibility: false,
    },
    {
      accessorKey: "FREQ_Organika_240",
      header: `ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 240L`,
      visibility: false,
      muiTableBodyCellEditTextFieldProps: {
        type: 'number',
        inputProps: { min: 0, max: 50 }
      }
    },

    {
      accessorKey: "TAGNO_Organika_360",
      header: `TAG ΟΡΓΑΝΙΚΩΝ 360L`,
      visibility: false,
    },
    {
      accessorKey: "RFID_Organika_360",
      header: `RFID ΟΡΓΑΝΙΚΩΝ 360L`,
      visibility: false,
    },
    {
      accessorKey: "FREQ_Organika_360",
      header: `ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 360L`,
      visibility: false,
      muiTableBodyCellEditTextFieldProps: {
        type: 'number',
        inputProps: { min: 0, max: 50 }
      }
    },

    {
      accessorKey: "TAGNO_Organika_660",
      header: `TAG ΟΡΓΑΝΙΚΩΝ 660L`,
      visibility: false,
    },
    {
      accessorKey: "RFID_Organika_660",
      header: `RFID ΟΡΓΑΝΙΚΩΝ 660L`,
      visibility: false,
    },
    {
      accessorKey: "FREQ_Organika_660",
      header: `ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 660L`,
      visibility: false,
      muiTableBodyCellEditTextFieldProps: {
        type: 'number',
        inputProps: { min: 0, max: 50 }
      }
    },

    {
      accessorKey: "TAGNO_Organika_1100",
      header: `TAG ΟΡΓΑΝΙΚΩΝ 1100L`,
      visibility: false,
    },
    {
      accessorKey: "RFID_Organika_1100",
      header: `RFID ΟΡΓΑΝΙΚΩΝ 1100L`,
      visibility: false,
    },
    {
      accessorKey: "FREQ_Organika_1100",
      header: `ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 1100L`,
      visibility: false,
      muiTableBodyCellEditTextFieldProps: {
        type: 'number',
        inputProps: { min: 0, max: 50 }
      }
    },

    {
      accessorKey: "WeeklyCollections_Organika_Freq",
      header: "ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΟΡΓΑΝΙΚΩΝ ΑΝΑ ΕΒΔΟΜΑΔΑ - ΣΥΧΝ.",
      size: 165,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "SumCollections",
      header: "ΣΥΝ.ΑΠΟΚΟΜΙΔΕΣ ΟΡΓΑΝΙΚΩΝ",
      size: 165,
      enableEditing: false,
      visibility: true,
    },    

    {
      accessorKey: "SumKg",
      header: `
      ΣΥΝ.ΚΙΛΑ 
      ΟΡΓΑΝΙΚΩΝ
      `,
      // size: 125,
      enableEditing: false,
      visibility: true,
    }, 

    

    
    //ΣΤΟΙΧΕΙΑ ΓΙΑ ΤΟΝ ΠΡΑΣΙΝΟ ΚΑΔΟ
    {
      accessorKey: "TAGNO_Symmeikta",
      header: `TAG ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ`,
      visibility: false,
    },   


    
    {
      accessorKey: "RFID_Symmeikta",
      header: `RFID  ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ`,
      visibility: false,

   },

   
   {
    accessorKey: "COVERNO_Symmeikta",
    header: `BINNo ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ`,
    visibility: true,
  },

  // New bin-size-specific fields for Symmeikta (Green bins)
  {
    accessorKey: "TAGNO_Symmeikta_120",
    header: `TAG ΣΥΜΜΕΙΚΤΩΝ 120L`,
    visibility: false,
  },
  {
    accessorKey: "RFID_Symmeikta_120",
    header: `RFID ΣΥΜΜΕΙΚΤΩΝ 120L`,
    visibility: false,
  },
  {
    accessorKey: "FREQ_Symmeikta_120",
    header: `ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 120L`,
    visibility: false,
    muiTableBodyCellEditTextFieldProps: {
      type: 'number',
      inputProps: { min: 0, max: 50 }
    }
  },

  {
    accessorKey: "TAGNO_Symmeikta_240",
    header: `TAG ΣΥΜΜΕΙΚΤΩΝ 240L`,
    visibility: false,
  },
  {
    accessorKey: "RFID_Symmeikta_240",
    header: `RFID ΣΥΜΜΕΙΚΤΩΝ 240L`,
    visibility: false,
  },
  {
    accessorKey: "FREQ_Symmeikta_240",
    header: `ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 240L`,
    visibility: false,
    muiTableBodyCellEditTextFieldProps: {
      type: 'number',
      inputProps: { min: 0, max: 50 }
    }
  },

  {
    accessorKey: "TAGNO_Symmeikta_360",
    header: `TAG ΣΥΜΜΕΙΚΤΩΝ 360L`,
    visibility: false,
  },
  {
    accessorKey: "RFID_Symmeikta_360",
    header: `RFID ΣΥΜΜΕΙΚΤΩΝ 360L`,
    visibility: false,
  },
  {
    accessorKey: "FREQ_Symmeikta_360",
    header: `ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 360L`,
    visibility: false,
    muiTableBodyCellEditTextFieldProps: {
      type: 'number',
      inputProps: { min: 0, max: 50 }
    }
  },

  {
    accessorKey: "TAGNO_Symmeikta_660",
    header: `TAG ΣΥΜΜΕΙΚΤΩΝ 660L`,
    visibility: false,
  },
  {
    accessorKey: "RFID_Symmeikta_660",
    header: `RFID ΣΥΜΜΕΙΚΤΩΝ 660L`,
    visibility: false,
  },
  {
    accessorKey: "FREQ_Symmeikta_660",
    header: `ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 660L`,
    visibility: false,
    muiTableBodyCellEditTextFieldProps: {
      type: 'number',
      inputProps: { min: 0, max: 50 }
    }
  },

  {
    accessorKey: "TAGNO_Symmeikta_1100",
    header: `TAG ΣΥΜΜΕΙΚΤΩΝ 1100L`,
    visibility: false,
  },
  {
    accessorKey: "RFID_Symmeikta_1100",
    header: `RFID ΣΥΜΜΕΙΚΤΩΝ 1100L`,
    visibility: false,
  },
  {
    accessorKey: "FREQ_Symmeikta_1100",
    header: `ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 1100L`,
    visibility: false,
    muiTableBodyCellEditTextFieldProps: {
      type: 'number',
      inputProps: { min: 0, max: 50 }
    }
  },

  {
    accessorKey: "WeeklyCollections_Symmeikta_Freq",
    header: "ΣΥΝ. ΑΠΟΚΟΜΙΔΕΣ ΣΥΜΜΕΙΚΤΩΝ ΑΝΑ ΕΒΔΟΜΑΔΑ - ΣΥΧΝ.",
    size: 165,
    enableEditing: false,
    visibility: false,
  },

  {
    accessorKey: "SumCollections_Symmeikta",
    header: "ΣΥΝ.ΑΠΟΚΟΜΙΔΕΣ ΣΥΜΜΕΙΚΤΩΝ",
    size: 165,
    enableEditing: false,
    visibility: true,
  },
  
  {
    accessorKey: "SumKg_Symmeikta",
    header: `
    ΣΥΝ.ΚΙΛΑ 
    ΣΥΜΜΕΙΚΤΩΝ
    `,
    size: 135,
    enableEditing: false,
    visibility: true,
  },



   
    //ΣΤΟΙΧΕΙΑ ΥΠΟΛΟΓΙΣΜΟΥ ΠΑΓΙΟΥ ΚΟΣΤΟΥΣ
    {
      accessorKey: "TetrMetraDT",
      header: `Τ.Μ. ΑΚΙΝΗΤΟΥ (ΔT)`,
      // size: 100,
      visibility: false,
    },

    {
      accessorKey: "Syntelestis",
      header: `ΣΥΝΤΕΛΕΣΤΗΣ (ΔT) (€/Τ.Μ.)`,
      size: 145,
      enableEditing: false,
      visibility: false,

    },



    //ΣΤΟΙΧΕΙΑ ΥΠΟΛΟΓΙΣΜΟΥ ΔΤ
    {
      accessorKey: "SumCost",
      header: `ΚΟΣΤΟΣ 
      ΟΡΓΑΝΙΚΩΝ(€)`,
      size: 145,
      enableEditing: false,
      visibility: false,
    },
    
   
    {
      accessorKey: "SumCost_Symmeikta",
      header: `ΚΟΣΤΟΣ 
      ΣΥΜΜΕΙΚΤΩΝ(€)`,
      size: 165,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "NewDT",
      header: `ΝΕΑ ΔΤ (€) ΧΩΡΙΣ ΚοΔ`,
      // size: 123,
      enableEditing: false,
      visibility: false,
    },

    // {
    //   accessorKey: "Discount",
    //   header: "ΕΚΠΤΩΣΗ ΕΦΑΡΜΟΓΗΣ ΚοΔ",      
    //   enableEditing: false,
    //   visibility: false,
    // },

    {
      accessorKey: "NewDT_Kod",
      header: "ΝΕΑ ΔΤ(€)",
      size: 165,
      enableEditing: false,
      visibility: true,
    },

    {
      accessorKey: "YfistamenaDT",
      header: `ΥΦΙΣΤΑΜΕΝΑ 
      ΔΤ(€)`,
      size: 135,
      enableEditing: false,
      visibility: true,
    },

    {
      accessorKey: "Anadromiki",
      header: `
      ΠΟΣΟ ΑΝΑΔΡΟΜΙΚΗΣ
      ΧΡΕΩΣΗΣ ΔΤ(€)
      `,
      enableEditing: false,
      visibility: true,
    },

    {
      accessorKey: "Metavoli",
      header: `
      ΜΕΤΑΒΟΛΗ ΔΤ (%)
      `,
      enableEditing: false,
      visibility: true,
    },

    {
      accessorKey: "SumCost_Organika_Freq",
      header: "ΚΟΣΤΟΣ ΟΡΓΑΝΙΚΩΝ(€) - ΣΥΧΝ.",
      size: 145,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "SumCost_Symmeikta_Freq",
      header: "ΚΟΣΤΟΣ ΣΥΜΜΕΙΚΤΩΝ(€) - ΣΥΧΝ.",
      size: 145,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "NewDT_Freq",
      header: "ΝΕΑ ΔΤ (€) ΧΩΡΙΣ ΚΟΔ - ΣΥΧΝ.",
      size: 145,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "Anadromiki_Freq",
      header: "ΠΟΣΟ ΑΝΑΔΡΟΜΙΚΗΣ ΧΡΕΩΣΗΣ ΔΤ(€) - ΣΥΧΝ.",
      size: 165,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: "Metavoli_Freq",
      header: "ΜΕΤΑΒΟΛΗ ΔΤ (%) - ΣΥΧΝ.",
      size: 145,
      enableEditing: false,
      visibility: false,
    },

    {
      accessorKey: 'Notes',
      header: 'ΠΑΡΑΤΗΡΗΣΕΙΣ',
      size: 350,
      visibility: true,

    },

    {
      accessorKey: "diffDays",
      header: "ΗΜΕΡΕΣ ΕΠΙΛΕΓΜΕΝΗΣ ΧΡΟΝΙΚΗΣ ΠΕΡΙΟΔΟΥ",
      size: 145,
      enableEditing: false,
      visibility: false,

    },


  ], []);

  // Visibility of columns
  // the value inside the object is the default visibility of the column
  //it is not used in the code
  //it is used only as a reference for the above columnsNew array
  const visibility = {
    id: true,
    EPONIMIA: true,
    BUSINESS_TYPE: true,
    AFM: false,
    ROAD: true,
    ROADNO: true,
    Municipality: false,
    CITY: true,
    TK: false,
    Latitude: false,
    Longtitude: false,
    AAPAROXIS: false,
    FLNAME: false,
    FLNAME1: false,
    PHONENO: false,
    MOBILENO: false,
    EMAIL: false,
    TAGNO: false,
    RFID: false,
    COVERNO: true,
    // New Organika bin sizes
    TAGNO_Organika_120: false,
    RFID_Organika_120: false,
    FREQ_Organika_120: false,
    TAGNO_Organika_240: false,
    RFID_Organika_240: false,
    FREQ_Organika_240: false,
    TAGNO_Organika_360: false,
    RFID_Organika_360: false,
    FREQ_Organika_360: false,
    TAGNO_Organika_660: false,
    RFID_Organika_660: false,
    FREQ_Organika_660: false,
    TAGNO_Organika_1100: false,
    RFID_Organika_1100: false,
    FREQ_Organika_1100: false,
    WeeklyCollections_Organika_Freq: false,
    SumCollections: true,
    SumKg: true,
    TAGNO_Symmeikta: false,
    RFID_Symmeikta: false,
    COVERNO_Symmeikta: true,
    // New Symmeikta bin sizes
    TAGNO_Symmeikta_120: false,
    RFID_Symmeikta_120: false,
    FREQ_Symmeikta_120: false,
    TAGNO_Symmeikta_240: false,
    RFID_Symmeikta_240: false,
    FREQ_Symmeikta_240: false,
    TAGNO_Symmeikta_360: false,
    RFID_Symmeikta_360: false,
    FREQ_Symmeikta_360: false,
    TAGNO_Symmeikta_660: false,
    RFID_Symmeikta_660: false,
    FREQ_Symmeikta_660: false,
    TAGNO_Symmeikta_1100: false,
    RFID_Symmeikta_1100: false,
    FREQ_Symmeikta_1100: false,
    WeeklyCollections_Symmeikta_Freq: false,
    SumCollections_Symmeikta: true,
    SumKg_Symmeikta: true,
    TetrMetraDT: false,
    Syntelestis: false,
    SumCost: false,
    SumCost_Symmeikta: false,
    NewDT: false,
    Discount: false,
    NewDT_Kod: true,
    YfistamenaDT: true,
    Anadromiki: true,
    Metavoli: true,
    SumCost_Organika_Freq: false,
    SumCost_Symmeikta_Freq: false,
    NewDT_Freq: false,
    Anadromiki_Freq: false,
    Metavoli_Freq: false,
    Notes: true,
    diffDays: false,

    

  };

  // const getHeaders = () => {
  //   let headers = [];

  //   for (let index = 0; index < columnsNew.length; index++) {
  //     const element = columnsNew[index];
  //     headers.push(element.header);
  //   }

  //   return headers;
  // };

  // const csvOptions = {
  //   fieldSeparator: ",",

  //   quoteStrings: '"',

  //   decimalSeparator: ".",

  //   showLabels: true,

  //   useBom: false,

  //   useKeysAsHeaders: true,

  //   headers: columnsNew.map((c) => c.header),
  // };

  const exportToExcel = (data) => {
    let visible_cols = tableInstanceRef.current.getVisibleLeafColumns();

    const worksheet = XLSX.utils.json_to_sheet(
      data.map((row) => {
        // console.log(row)
        const datas = {};

        for (let index = 0; index < columnsNew.length; index++) {
          const element = columnsNew[index];

          var result = visible_cols.find((obj) => {
            return obj.id === element.accessorKey;
          });

          if (result) {
            const value = row[`${element.accessorKey}`];
            if (!isNaN(value) && value !== null && value !== "") {
              datas[`${element.header}`] = parseFloat(value);
            } else {
              datas[`${element.header}`] = value;
            }
          }
        }

        return datas;
      })
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "data.xlsx");

    // accessorKey: 'DxrXrDTDF',
    //   header: 'DxrXrDTDF',
  };

  // const csvExporter = new ExportToCsv(csvOptions);

  // Check if user has permission to edit
  const hasEditPermission = useCallback(() => {
    if (!user || !user.role) return false;
    return user.role === 'admin' || user.role === 'user3';
  }, [user]);

  //for exapmle adding a new row or deleting a row
  const hasAddOrDeletePermission = useCallback(() => {
    if (!user || !user.role) return false;
    return user.role === 'admin'
  }, [user]);

  const showPermissionMessage = useCallback((message = "You don't have permission for this action.") => {
    setPermissionErrorMessage(message);
    setShowPermissionError(true);
    setTimeout(() => setShowPermissionError(false), 3000);
  }, []);

  // New Business Form Handlers
  const handleOpenAddDialog = useCallback(() => {
    if (!hasAddOrDeletePermission()) {
      showPermissionMessage("You can't add rows! Only admin role is allowed to add new rows.");
      return;
    }
    setOpenAddDialog(true);
  }, [hasAddOrDeletePermission, showPermissionMessage]);

  const handleCloseAddDialog = useCallback(() => {
    setOpenAddDialog(false);
    // Reset form to initial empty values
    reset();
  }, [reset]);

  // React Hook Form submission handler
  const onSubmitNewBusiness = async (formData) => {
    try {
      // Validate required fields
      if (!formData.EPONIMIA.trim()) {
        showPermissionMessage("Το όνομα επιχείρησης είναι υποχρεωτικό!");
        return;
      }
      if (!formData.AAPAROXIS.trim()) {
        showPermissionMessage("Ο αριθμός παροχής είναι υποχρεωτικός!");
        return;
      }
      if (!formData.ROAD.trim()) {
        showPermissionMessage("Η οδός είναι υποχρεωτική!");
        return;
      }
      if (!formData.ROADNO.trim()) {
        showPermissionMessage("Ο αριθμός οδού είναι υποχρεωτικός!");
        return;
      }
      if (!formData.TK.trim()) {
        showPermissionMessage("Ο ταχυδρομικός κώδικας είναι υποχρεωτικός!");
        return;
      }

      await addDataRequest(formData);
      setDidAdd(didAdd + 1);
      setDidAddNew(true);
      handleCloseAddDialog();
      
      // Scroll to the new entry
      setTimeout(() => {
        if (virtualizerInstanceRef.current) {
          virtualizerInstanceRef.current.scrollToIndex(data?.count || 0);
        }
      }, 100);
      
    } catch (error) {
      console.error("Error adding business:", error);
      showPermissionMessage("Σφάλμα κατά την προσθήκη επιχείρησης!");
    }
  };

  const handleExportRows = (rows) => {
    
    exportToExcel(data.rows);
  };

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    // Check permissions before allowing edit
    if (!hasEditPermission()) {
      showPermissionMessage("You can't edit! Only admin and user3 roles are allowed to edit.");
      exitEditingMode();
      return;
    }

    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    console.log(values);
    data.rows[row.index] = values;

    try {
      await updateDataRequest({ id: values.id, data: values });
      setDidSaved(didSaved + 1);
    } catch (error) { }

    exitEditingMode(); //required to exit editing mode
  };

  const handleDeleteRow = async (row) => {
    // Check permissions before allowing delete
    if (!hasAddOrDeletePermission()) {
      showPermissionMessage("You can't delete! Only admin role is allowed to delete rows.");
      return;
    }

    // console.log(row.original.id);
    try {
      await deleteDataRequest(row.original.id);
      setDidSaved(didSaved + 1);
      // setDidAddNew(true);
      //             virtualizerInstanceRef.current.scrollToIndex(data.count);
    } catch (error) { }
  };

  if (isLoading)
    return (
      <div className="flex flex-col w-full h-96 justify-center items-center ">
        <CircularProgress className="!text-app_green font-bold"></CircularProgress>
        <div className="pt-5">Loading Database</div>
        <div className="pt-5">This may take a while..</div>
      </div>
    );

  if (isError)
    return (
      <div className="flex p-8 justify-center h-screen items-center">
        <div className=" text-center">
          <p className="texgt-md font-medium">ERROR LOADING DATA: { } </p>
        </div>
      </div>
    );

  // if (data.length < 1)
  //   return <div className='flex p-8 justify-center h-screen items-center'>
  //     <div className=' text-center'>
  //       <p className='texgt-md font-medium'>No Data To Load</p>
  //     </div>
  //   </div>

  // console.log(didAddNew);
  if (didAddNew) {

    //wait for the virtualizer to initialize
    setTimeout(() => {
      virtualizerInstanceRef.current.scrollToIndex(data.count);
      //set the whole page to the bottom
      window.scrollTo(0, document.body.scrollHeight);
    }, 100);

    setDidAddNew(false);
  }




  return (
    <div className="_flex grow !h-96 z-0 max-w-full _overflow-hidden">
      <MaterialReactTable
        columns={columnsNew}
        tableInstanceRef={tableInstanceRef}
        data={!isLoading ? data.rows : []}
        // rowVirtualizerInstanceRef={virtualizerInstanceRef}
        // enableRowVirtualization={true}
        // rowVirtualizerProps={{
        //   overscan: 10,
        //   estimateSize: () => 50,
        // }}
        state={{ 
          isLoading: isLoading,
          showSkeletons: isLoading
        }}
        enableEditing
        onEditingRowSave={handleSaveRow}
        
        muiTableHeadCellProps={{

          sx: {

            fontSize: '0.75rem',



          },

        }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "Edit", //change "Actions" to "Edit"
          },
        }}
        enableColumnResizing
        enableStickyHeader={true}
        enablePagination={false}
        enableBottomToolbar={false}
        enableTopToolbar={true}
        enableRowNumbers={false}
        enableRowSelection={false}
        enableMultiRowSelection={false}
        enableGlobalFilter={true}
        enableColumnFilters={true}
        enableHiding={true}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        muiTableContainerProps={{
          sx: {
            maxHeight: () => {
              return `calc(100vh - 305px)`
            }
          }
        }}
        muiTableBodyRowProps={{
          sx: {
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          },
        }}



        initialState={{
          density: "compact",
          columnVisibility: visibility,
          showColumnFilters: false, // Start with filters hidden for performance, but allow users to enable them
          showGlobalFilter: true, // Enable global search
          pagination: { pageSize: data ? data.count : 1500, pageIndex: 0 },
        }}
        muiTablePaginationProps={{
          rowsPerPageOptions: [data ? data.count : 1500],
        }}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", gap: "-1rem", width: 100 }}>
            <Tooltip arrow placement="left" title={hasEditPermission() ? "Edit" : "You can't edit"}>
              <span>
                <IconButton
                  className="!w-8"
                  disabled={!hasEditPermission()}
                  onClick={() => {
                    if (hasEditPermission()) {
                      table.setEditingRow(row);
                    } else {
                      showPermissionMessage("You can't edit! Only admin and user3 roles are allowed to edit.");
                    }
                  }}
                >
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>

            {/* render delete only if the EPONIMIA field is "New Bussines" and user has permission */}
            {row._valuesCache.EPONIMIA === "NEW BUSINESS" && (
              <Tooltip arrow placement="left" title={hasAddOrDeletePermission() ? "Delete" : "You can't delete"}>
                <span>
                  <IconButton
                    className="!w-8"
                    disabled={!hasAddOrDeletePermission()}
                    onClick={() => {
                      if (hasAddOrDeletePermission()) {
                        handleDeleteRow(row);
                      } else {
                        showPermissionMessage("You can't delete! Only admin role is allowed to delete rows.");
                      }
                    }}
                  >
                    <Delete />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </Box>
        )}
        renderTopToolbarCustomActions={({ table }) => (
          <div className=" flex justify-between !z-50">
            <div className="flex space-x-3">
              <Fab
                color="main"
                className="button !shadow-sm text-xl text-white w-9 h-8"
                size="small"
                onClick={() => {
                  handleExportRows(table.getFilteredRowModel().rows);
                }}
              >
                <Download></Download>
              </Fab>
              <Tooltip title={hasAddOrDeletePermission() ? "Add new business" : "You can't add rows"}>
                <span>
                  <Fab
                    color="main"
                    className="button !shadow-sm text-xl text-white w-9 h-8"
                    size="small"
                    disabled={!hasAddOrDeletePermission()}
                    onClick={handleOpenAddDialog}
                  >
                    <Add></Add>
                  </Fab>
                </span>
              </Tooltip>

              <Fab
                color="main"
                className="button !shadow-sm text-xl text-white w-9 h-8"
                size="small"
                onClick={async () => {
                  virtualizerInstanceRef.current.scrollToIndex(
                    data.count + 100
                  );
                  window.scrollTo(0, document.body.scrollHeight);
                }}
              >
                <BsArrowDown></BsArrowDown>
              </Fab>

              {/* add a clean empty fields button that deletes the fields where EPONIMIA is "New Bussiness" */}
              {/* <div
                className="button bg-['#F5F5F5] flex !shadow-sm text-sm "
                onClick={async () => {
                  let new_data = data.rows.filter(
                    (row) => row.EPONIMIA !== "New Bussiness"
                  );
                  // setData({ ...data, rows: new_data });
                }}
              >
                Διαγραφη κενων καταψορισεων <BsTrash></BsTrash>
              </div> */}
            </div>

            <div></div>
          </div>
        )}

      //
      />

      {/* <div className="mt-10 flex space-x-5" style={{ textAlign: "center" }}>
        <h1>Ανέβασμα αρχείου excel </h1>
        <form className="flex justify-center">
          <input
            type={"file"}
            id={"csvFileInput"}
            accept={".csv"}
            //  onChange={handleOnChange}
          />
          <div
            className=" bg-green-400 text-white rounded-3xl px-5 cursor-pointer"
            onClick={(e) => {
              //  handleOnSubmit(e);
            }}
          >
            Ανέβασμα
          </div>
        </form>
      </div> */}

      {/* Permission Error Snackbar */}
      <Snackbar
        open={showPermissionError}
        autoHideDuration={3000}
        onClose={() => setShowPermissionError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setShowPermissionError(false)} 
          severity="error" 
          sx={{ width: '100%' }}
        >
          {permissionErrorMessage}
        </Alert>
      </Snackbar>

      {/* Add New Business Dialog */}
      <Dialog 
        open={openAddDialog} 
        onClose={handleCloseAddDialog} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: '#f8f9fa',
          }
        }}
      >
        <DialogTitle 
          sx={{ 
            backgroundColor: '#2196f3', 
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          Δημιουργία Νέας Επιχείρησης
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmitNewBusiness)}>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {/* Section 1: Basic Business Info */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 1, color: '#2196f3', fontWeight: 'bold' }}>
                Στοιχεία Επιχείρησης
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Controller
                name="EPONIMIA"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Όνομα Επιχείρησης *"
                    variant="outlined"
                    required
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="AAPAROXIS"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Α.ΠΑΡΟΧΗΣ *"
                    variant="outlined"
                    required
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Controller
                name="AFM"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΑΦΜ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="TetrMetraDT"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Τ.Μ. ΑΚΙΝΗΤΟΥ (ΔT)"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* Section 2: Address */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#2196f3', fontWeight: 'bold' }}>
                Διεύθυνση Ακινήτου
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Controller
                name="ROAD"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΟΔΟΣ *"
                    variant="outlined"
                    required
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="ROADNO"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΑΡΙΘΜΟΣ *"
                    variant="outlined"
                    required
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="TK"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TK *"
                    variant="outlined"
                    required
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth variant="outlined" sx={{ mb: 1 }}>
                <InputLabel>Δ.Ε.</InputLabel>
                <Controller
                  name="CITY"
                  control={control}
                  render={({ field }) => (
                    <Select {...field} label="Δ.Ε.">
                      <MenuItem value="ΒΟΥΛΑ">ΒΟΥΛΑ</MenuItem>
                      <MenuItem value="ΒΟΥΛΙΑΓΜΕΝΗ">ΒΟΥΛΙΑΓΜΕΝΗ</MenuItem>
                      <MenuItem value="ΒΑΡΗ">ΒΑΡΗ</MenuItem>
                      <MenuItem value="ΒΑΡΚΙΖΑ">ΒΑΡΚΙΖΑ</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>

            {/* Geographic Coordinates */}
            <Grid item xs={12} md={6}>
              <Controller
                name="Latitude"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΓΕΩΓΡ.ΠΛΑΤΟΣ"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="Longtitude"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΓΕΩΓΡ.ΜΗΚΟΣ"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* Section 3: Ownership & Contact */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#2196f3', fontWeight: 'bold' }}>
                Στοιχεία Παροχής & Επικοινωνίας
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="FLNAME"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΙΔΙΟΚΤΗΤΗΣ ΑΡ. ΠΑΡΟΧΗΣ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="FLNAME1"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΥΠΕΥΘΥΝΟΣ ΕΠΙΚΟΙΝΩΝΙΑΣ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="PHONENO"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΤΑΘΕΡΟ ΤΗΛΕΦΩΝΟ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="MOBILENO"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΚΙΝΗΤΟ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="EMAIL"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="EMAIL"
                    variant="outlined"
                    type="email"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* Section 4: Brown Container (Καφέ Κάδος) */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#8d6e63', fontWeight: 'bold' }}>
                Στοιχεία για τον Καφέ Κάδο (Οργανικά)
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΚΑΦΕ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΚΑΦΕ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="COVERNO"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="BINNo ΚΑΦΕ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* New Organika Bin Sizes */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mt: 1, mb: 1, color: '#6d4c41', fontWeight: 'bold' }}>
                Κάδοι Οργανικών ανά Μέγεθος
              </Typography>
            </Grid>

            {/* 120L Organika */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Organika_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΟΡΓΑΝΙΚΩΝ 120L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Organika_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΟΡΓΑΝΙΚΩΝ 120L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Organika_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 120L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 240L Organika */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Organika_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΟΡΓΑΝΙΚΩΝ 240L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Organika_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΟΡΓΑΝΙΚΩΝ 240L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Organika_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 240L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 360L Organika */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Organika_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΟΡΓΑΝΙΚΩΝ 360L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Organika_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΟΡΓΑΝΙΚΩΝ 360L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Organika_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 360L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 660L Organika */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Organika_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΟΡΓΑΝΙΚΩΝ 660L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Organika_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΟΡΓΑΝΙΚΩΝ 660L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Organika_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 660L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 1100L Organika */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Organika_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΟΡΓΑΝΙΚΩΝ 1100L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Organika_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΟΡΓΑΝΙΚΩΝ 1100L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Organika_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΟΡΓΑΝΙΚΩΝ 1100L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* Section 5: Green Container (Πράσινος Κάδος) */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#4caf50', fontWeight: 'bold' }}>
                Στοιχεία για τον Πράσινο Κάδο (Σύμμεικτα)
              </Typography>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="COVERNO_Symmeikta"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="BINNo ΠΡΑΣΙΝΟΥ ΚΑΔΟΥ"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* New Symmeikta Bin Sizes */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mt: 1, mb: 1, color: '#388e3c', fontWeight: 'bold' }}>
                Κάδοι Συμμείκτων ανά Μέγεθος
              </Typography>
            </Grid>

            {/* 120L Symmeikta */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΣΥΜΜΕΙΚΤΩΝ 120L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΣΥΜΜΕΙΚΤΩΝ 120L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Symmeikta_120"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 120L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 240L Symmeikta */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΣΥΜΜΕΙΚΤΩΝ 240L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΣΥΜΜΕΙΚΤΩΝ 240L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Symmeikta_240"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 240L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 360L Symmeikta */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΣΥΜΜΕΙΚΤΩΝ 360L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΣΥΜΜΕΙΚΤΩΝ 360L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Symmeikta_360"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 360L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 660L Symmeikta */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΣΥΜΜΕΙΚΤΩΝ 660L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΣΥΜΜΕΙΚΤΩΝ 660L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Symmeikta_660"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 660L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* 1100L Symmeikta */}
            <Grid item xs={12} md={4}>
              <Controller
                name="TAGNO_Symmeikta_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="TAG ΣΥΜΜΕΙΚΤΩΝ 1100L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="RFID_Symmeikta_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="RFID ΣΥΜΜΕΙΚΤΩΝ 1100L"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Controller
                name="FREQ_Symmeikta_1100"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΣΥΧΝΟΤΗΤΑ ΣΥΜΜΕΙΚΤΩΝ 1100L"
                    variant="outlined"
                    type="number"
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>

            {/* Section 6: Notes */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#2196f3', fontWeight: 'bold' }}>
                Παρατηρήσεις
              </Typography>
            </Grid>
            
            <Grid item xs={12}>
              <Controller
                name="Notes"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="ΠΑΡΑΤΗΡΗΣΕΙΣ"
                    variant="outlined"
                    multiline
                    rows={3}
                    sx={{ mb: 1 }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, backgroundColor: '#f0f0f0' }}>
          <Button 
            onClick={handleCloseAddDialog}
            variant="outlined"
            sx={{ mr: 1, textTransform: 'none' }}
          >
            Ακύρωση
          </Button>
          <Button 
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: '#4caf50',
              '&:hover': { backgroundColor: '#45a049' },
              textTransform: 'none'
            }}
          >
            Αποθήκευση
          </Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default DataTable;
